import * as ShiftRequest from './shift_soap/index.js'

jQuery(document).ready(function ($) {
    async function postData(url = '', data = {}) {
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            redirect: 'follow',
            referrerPolicy: 'origin-when-cross-origin',
            body: JSON.stringify(data)
        });

        return response.json();
    }

    function selectElement(id, valueToSelect) {
        let element = document.getElementById(id);
        element.value = valueToSelect;
    }

//// FROM HERE

    function debounce(callback, delay) {
        var timeout
        return function () {
            var args = arguments
            clearTimeout(timeout)
            timeout = setTimeout(function () {
                callback.apply(this, args)
            }.bind(this), delay)
        }
    }

    let getPriceData = {
        sourceCountryId: 232,
        platform: 'LT',
        supportSourceLoyality: 'YES'
    }
    /*
      sourceCountryId
      platform
      supportSourceLoyality
      destinationCountryId
      serviceTypes
      serviceType
      requiredBranch
      serviceProviderId
      cityId
      payoutBranchCode
      payingCurrencyId
      payoutCurrencyId
      payingAmount
      payoutAmount
    */

    let locationData = {
        countryId: 232,
        platform: 'UK'
    }

    /*
      countryId
      cityCode
      platform
    */

    let transferData = {
        platform: 'LT'
    }

    /*
      remittancTrackingCode
      platform
    */
    const btnB = document.querySelector('#priceCalc');
    const markers = [];

    function updatePriceInputs(step) {
        $('[data-step]').each(function () {
            if ($(this).data('step') >= step) {
                $(this).empty()
                if ($(this).is('select')) $(this).append($('<option>', {value: 0, text: ''}))
                if ($(this).is('input')) $(this).val(0)
            }
        })

        $('[data-show]').each(function () {
            if ($(this).data('show').includes(step)) {
                $(this).removeClass('hidden-item')
            } else $(this).addClass('hidden-item')
        })
    }

    async function runPriceState(state = 'init', props = {}) {
        getPriceData = {...getPriceData, ...props}

// COUNTRY SELECT
        if (state === 'init') {
            updatePriceInputs(1)
            //destination
            const destCountry = document.querySelector('#destination-countries + .select2');
            destCountry.classList.add('selector-disabled');
            destCountry.style.pointerEvents = 'none';

            const serviceType = document.querySelector('#service-type + .select2');
            serviceType.style.pointerEvents = 'none';
            serviceType.classList.add('selector-disabled');

            const serviceTyp = document.querySelector('#service-provider + .select2');
            serviceTyp.style.pointerEvents = 'none';
            serviceTyp.classList.add('selector-disabled');

            const source_countries = await ShiftRequest._getSourceCountries();
            // const source_countries = await postData('http://localhost:3000/getSourceCountries', {})

            source_countries.forEach((sc) => {
                $('#source-countries').append($('<option>', {
                    value: `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}_${sc['ns3:supportSourceLoyality']._}`,
                    text: sc['ns3:countryNameEn']._,
                    selected: sc['ns3:countryId']._ === 232
                }));
            })

            if (document.querySelector('.source-countries-list')) {
                const locationList = document.querySelector('.source-countries-list');
                const countrySelect = document.querySelector('#source-countries');
                locationList.innerHTML = '';

                source_countries.forEach(sc => {
                    let div = document.createElement('div');
                    div.classList.add('source-countries');
                    div.classList.add('country-block');

                    let flagSpan = document.createElement('span');
                    flagSpan.classList.add('country-flag');

                    let flagSpanImg = document.createElement('img');

                    let getId = `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}_${sc['ns3:supportSourceLoyality']._}`;
                    let str = getId.substr(0, getId.indexOf('_'));
                    // flagSpanImg.setAttribute(`src`, `/assets/images/flags/${str}.png`);

                    flagSpan.setAttribute('data-country', sc['ns3:countryNameEn']._);
                    flagSpan.setAttribute('data-country-id', `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}_${sc['ns3:supportSourceLoyality']._}`);
                    flagSpan.setAttribute('data-id', str);

                    div.setAttribute('data-country', sc['ns3:countryNameEn']._);
                    div.setAttribute('data-country-id', `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}_${sc['ns3:supportSourceLoyality']._}`);
                    div.setAttribute('data-id', str);

                    let span = document.createElement('span');
                    span.setAttribute('data-country-id', `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}_${sc['ns3:supportSourceLoyality']._}`);
                    // span.setAttribute('data-selected-country-id', sc['ns3:countryId']._ === 127);
                    span.setAttribute('data-id', str);
                    span.setAttribute('data-country', sc['ns3:countryNameEn']._);
                    span.classList.add('selected-country');

                    span.textContent = sc['ns3:countryNameEn']._;

                    flagSpan.append(flagSpanImg);
                    div.append(flagSpan);
                    div.append(span);
                    locationList.append(div);

                    if (div.getAttribute('data-country-id').includes('127')) {
                        div.classList.add('active');

                        const cloneNode = div.cloneNode(true);
                        const active = document.querySelector('.active-source-contries');
                        active.innerHTML = '';
                        active.append(cloneNode);
                    }

                    div.addEventListener('click', function () {
                        countrySelect.value = this.getAttribute('data-country-id');
                        countrySelect.dispatchEvent(new Event("change"));

                        this.classList.add('active-block');

                        const cloneNode = this.cloneNode(true);

                        const active = document.querySelector('.active-source-contries');
                        active.innerHTML = '';

                        active.append(cloneNode);
                    });
                });
            }

            searchField('.input-box-price', '.source-countries-list .country-block');
            runPriceState('source-country-selected')
        }

        if (state === 'source-country-selected') {
            updatePriceInputs(2)
            const {sourceCountryId, platform} = getPriceData

            const dest_countries = await ShiftRequest._getDestinationCountries(sourceCountryId, platform);

            dest_countries.forEach((dc) => {
                const destCountry = document.querySelector('#destination-countries + .select2');
                destCountry.classList.remove('selector-disabled');
                destCountry.style.pointerEvents = 'all';
                $('#destination-countries').append($('<option>', {
                    value: `${dc['ns3:countryId']._}_ST:${JSON.stringify(dc['ns3:serviceTypes'])}`,
                    text: dc['ns3:countryNameEn']._
                }));
            })

            if (document.querySelector('.destination-countries-list')) {
                const locationList = document.querySelector('.destination-countries-list');
                const countrySelect = document.querySelector('#destination-countries');
                locationList.innerHTML = '';

                dest_countries.forEach(dc => {
                    let div = document.createElement('div');
                    div.classList.add('destination-countries');
                    div.classList.add('country-block');

                    let flagSpan = document.createElement('span');
                    flagSpan.classList.add('country-flag');

                    let flagSpanImg = document.createElement('img');

                    let getId = `${dc['ns3:countryId']._}_ST:${JSON.stringify(dc['ns3:serviceTypes'])}`;
                    let str = getId.substr(0, getId.indexOf('_'));
                    // flagSpanImg.setAttribute(`src`, `/assets/images/flags/${str}.png`);

                    flagSpan.setAttribute('data-country', dc['ns3:countryNameEn']._);
                    flagSpan.setAttribute('data-country-id', `${dc['ns3:countryId']._}_ST:${JSON.stringify(dc['ns3:serviceTypes'])}`);
                    flagSpan.setAttribute('data-id', str);

                    div.setAttribute('data-country', dc['ns3:countryNameEn']._);
                    div.setAttribute('data-country-id', `${dc['ns3:countryId']._}_ST:${JSON.stringify(dc['ns3:serviceTypes'])}`);
                    div.setAttribute('data-id', str);

                    let span = document.createElement('span');
                    span.setAttribute('data-country-id', `${dc['ns3:countryId']._}_ST:${JSON.stringify(dc['ns3:serviceTypes'])}`);
                    // span.setAttribute('data-selected-country-id', sc['ns3:countryId']._ === 127);
                    span.setAttribute('data-id', str);
                    span.setAttribute('data-country', dc['ns3:countryNameEn']._);
                    span.classList.add('selected-country');

                    span.textContent = dc['ns3:countryNameEn']._;

                    flagSpan.append(flagSpanImg);
                    div.append(flagSpan);
                    div.append(span);
                    locationList.append(div);

                    if (div.getAttribute('data-country-id').includes('127')) {
                        div.classList.add('active');
                        //
                        // const cloneNode = div.cloneNode(true);
                        // const active = document.querySelector('.active-destination-countries');
                        // active.innerHTML = '';
                        // active.append(cloneNode);
                    }

                    div.addEventListener('click', function () {
                        countrySelect.value = this.getAttribute('data-country-id');
                        countrySelect.dispatchEvent(new Event("change"));

                        this.classList.add('active-block');

                        const cloneNode = this.cloneNode(true);

                        const active = document.querySelector('.active-destination-countries');
                        active.innerHTML = '';

                        active.append(cloneNode);
                    });
                });
            }

            searchField('.input-box-price-2', '.destination-countries-list .country-block');
        }

        if (state === 'destination-country-selected') {
            updatePriceInputs(3)
            const {serviceTypes} = getPriceData
            const serviceType = document.querySelector('#service-type + .select2');
            serviceType.style.pointerEvents = 'all';
            serviceType.classList.remove('selector-disabled');

            serviceTypes.forEach((st) => {
                $('#service-type').append($('<option>', {
                    value: st._,
                    text: st._
                }));
            })

            if (document.querySelector('.service-type-list')) {
                const locationList = document.querySelector('.service-type-list');
                const countrySelect = document.querySelector('#service-type');
                locationList.innerHTML = '';

                serviceTypes.forEach(st => {
                    let div = document.createElement('div');
                    div.classList.add('service-types');
                    div.classList.add('country-block');

                    let flagSpan = document.createElement('span');
                    flagSpan.classList.add('country-flag-money');

                    flagSpan.setAttribute('data-value', st._);

                    div.setAttribute('data-value', st._);

                    let flagSpanImg = document.createElement('img');

                    let span = document.createElement('span');
                    span.setAttribute('data-value', st._);
                    span.classList.add('selected-country');

                    span.textContent = st._;

                    flagSpan.append(flagSpanImg);
                    div.append(flagSpan);
                    div.append(span);
                    locationList.append(div);

                    div.addEventListener('click', function () {
                        countrySelect.value = this.getAttribute('data-value');
                        countrySelect.dispatchEvent(new Event("change"));

                        this.classList.add('active-block');

                        const cloneNode = this.cloneNode(true);

                        const active = document.querySelector('.active-service-types');
                        active.innerHTML = '';

                        active.append(cloneNode);
                    });
                });
            }
        }

        if (state === 'service-type-selected') {
            const {sourceCountryId, platform, destinationCountryId, serviceType} = getPriceData

            const serviceProviders = await ShiftRequest._getServiceProviders(sourceCountryId, destinationCountryId, serviceType, platform);
            // if(serviceType.toUpperCase() === 'CASH PICKUP'){
            //     const servProv = document.querySelector('[data-select2-id^="select2-data-6-"]');
            //     servProv.style.display = 'block';
            // }else{
            //     const servProv = document.querySelector('[data-select2-id^="select2-data-6-"]');
            //     servProv.style.display = 'none';
            // }
            const destCountryyy = document.querySelector('#service-provider + .select2');
            destCountryyy.classList.remove('selector-disabled');
            destCountryyy.style.pointerEvents = 'all';
            if (serviceProviders.length === 1 || serviceType.toUpperCase() !== 'CASH PICKUP') {

                getPriceData.serviceProviderId = serviceProviders[0]['ns3:serviceProviderId']._
                getPriceData.requiredBranch = serviceProviders[0]['ns3:requiredBranch']._
                updatePriceInputs(6)
                if (serviceProviders.length === 2) {


                }
            } else {
                // const servProv = document.querySelector('[data-select2-id^="select2-data-6-"]');
                // servProv.style.display = 'none';
                updatePriceInputs(4)
                serviceProviders.forEach((sp) => {
                    $('#service-provider').append($('<option>', {
                        value: `${sp['ns3:serviceProviderId']._}_${sp['ns3:requiredBranch']._}`,
                        text: sp['ns3:serviceProviderName']._
                    }));
                })
            }

            const service = document.querySelector('#service-provider');
            const servProv = document.querySelector('[data-select2-id^="select2-data-6-"]');

            if (!service.classList.contains('hidden-item')) {
                servProv.style.display = 'block';
            } else {
                servProv.style.display = 'none';
            }
        }

        if (state === 'service-provider-selected') updatePriceInputs(5)

        if (state === 'country-select-end') {
            const {requiredBranch, serviceType, destinationCountryId, platform, serviceProviderId} = getPriceData

            if (!requiredBranch || requiredBranch.toUpperCase() === 'NO') {
                runPriceState('amount-input-start')
            } else {
                // BRANCH CODE

                const countryCities = await ShiftRequest._getCountryCities(destinationCountryId, platform);

                getPriceData.cityId = countryCities[0]['ns3:cityId']._

                const branches = await ShiftRequest._getBranchesByServiceProvider(getPriceData.cityId, serviceProviderId, serviceType, platform);

                getPriceData.payoutBranchCode = branches[0]['ns3:branchCode']._
                runPriceState('amount-input-start')
            }
        }

// PRICE INPUTS
        if (state === 'amount-input-start') {
            updatePriceInputs(10)
            const {
                sourceCountryId,
                platform,
                destinationCountryId,
                serviceProviderId,
                serviceType,
                payoutBranchCode
            } = getPriceData

            const payingCurrencies = await ShiftRequest._getPayingCurrencies(sourceCountryId, platform);

            payingCurrencies.forEach((sp, i) => {
                if (!i) getPriceData.payingCurrencyId = sp['ns3:currenyId']._
                $('#paying-currency').append($('<option>', {
                    value: sp['ns3:currenyId']._,
                    text: `${sp['ns3:currenyISOCode']._}`,
                    selected: !i
                }));
            });

            if (document.querySelector('.paying-currency-list')) {


                const locationList = document.querySelector('.paying-currency-list');
                const countrySelect = document.querySelector('#paying-currency');

                locationList.innerHTML = '';
                paying - currency

                payingCurrencies.forEach((sp, i) => {
                    let div = document.createElement('div');
                    div.classList.add('paying-currencies');
                    div.classList.add('country-block');

                    let flagSpan = document.createElement('span');
                    flagSpan.classList.add('country-flag');

                    let flagSpanImg = document.createElement('img');

                    flagSpan.setAttribute('data-value', sp['ns3:currenyId']._);
                    flagSpan.setAttribute('data-country-iso', `${sp['ns3:currenyISOCode']._}`);
                    flagSpan.setAttribute('data-selected', !i);

                    div.setAttribute('data-value', sp['ns3:currenyId']._);
                    div.setAttribute('data-country-iso', `${sp['ns3:currenyISOCode']._}`);
                    div.setAttribute('data-selected', !i);

                    let span = document.createElement('span');
                    span.setAttribute('data-value', sp['ns3:currenyId']._);
                    span.setAttribute('data-country-iso', `${sp['ns3:currenyISOCode']._}`);
                    span.setAttribute('data-selected', !i);
                    span.classList.add('selected-country');

                    span.textContent = sp['ns3:currenyISOCode']._;

                    flagSpan.append(flagSpanImg);
                    div.append(flagSpan);
                    div.append(span);
                    locationList.append(div);

                    div.addEventListener('click', function () {
                        countrySelect.value = this.getAttribute('data-value');
                        countrySelect.dispatchEvent(new Event("change"));

                        this.classList.add('active-block');

                        const cloneNode = this.cloneNode(true);

                        const active = document.querySelector('.active-paying-amount');
                        active.innerHTML = '';

                        active.append(cloneNode);
                    });
                });
            }

            const payoutCurrencies = await ShiftRequest._getPayoutCurrencies(destinationCountryId, serviceProviderId, serviceType, platform, payoutBranchCode);

            payoutCurrencies.forEach((sp, i) => {
                if (!i) getPriceData.payoutCurrencyId = sp['ns3:currenyId']._
                $('#payout-currency').append($('<option>', {
                    value: sp['ns3:currenyId']._,
                    text: `${sp['ns3:currenyISOCode']._}`,
                    selected: !i
                }));
            });

            if (document.querySelector('.payout-currency-list')) {


                const locationList2 = document.querySelector('.payout-currency-list');
                const countrySelect2 = document.querySelector('#payout-currency');

                locationList2.innerHTML = '';

                payoutCurrencies.forEach((sp, i) => {
                    let div = document.createElement('div');
                    div.classList.add('payount-currencies');
                    div.classList.add('country-block');

                    let flagSpan = document.createElement('span');
                    flagSpan.classList.add('country-flag');

                    flagSpan.setAttribute('data-value', sp['ns3:currenyId']._);
                    flagSpan.setAttribute('data-country-iso', `${sp['ns3:currenyISOCode']._}`);
                    flagSpan.setAttribute('data-selected', !i);

                    div.setAttribute('data-value', sp['ns3:currenyId']._);
                    div.setAttribute('data-country-iso', `${sp['ns3:currenyISOCode']._}`);
                    div.setAttribute('data-selected', !i);

                    let flagSpanImg = document.createElement('img');

                    let span = document.createElement('span');
                    span.setAttribute('data-value', sp['ns3:currenyId']._);
                    span.setAttribute('data-country-iso', `${sp['ns3:currenyISOCode']._}`);
                    span.setAttribute('data-selected', !i);
                    span.classList.add('selected-country');

                    span.textContent = sp['ns3:currenyISOCode']._;

                    flagSpan.append(flagSpanImg);
                    div.append(flagSpan);
                    div.append(span);
                    locationList2.append(div);

                    div.addEventListener('click', function () {
                        countrySelect2.value = this.getAttribute('data-value');
                        countrySelect2.dispatchEvent(new Event("change"));

                        this.classList.add('active-block');

                        const cloneNode = this.cloneNode(true);

                        const active = document.querySelector('.active-payout-amount');
                        active.innerHTML = '';

                        active.append(cloneNode);
                    });
                });
            }
        }

        if (state === 'currency-changed') {
            $('#paying-amount').val(0)
            $('#payout-amount').val(0)
            updatePriceInputs(11)
        }

        if (state === 'paying-amount-changed') {
            $('#payout-amount').val(0)
            updatePriceInputs(11)

            let {
                serviceType,
                serviceProviderId,
                sourceCountryId,
                destinationCountryId,
                payingCurrencyId,
                payoutCurrencyId,
                payingAmount,
                platform,
                payoutBranchCode,
                requiredBranch,
                supportSourceLoyality
            } = getPriceData

            if (!payingCurrencyId || !payoutCurrencyId) return

            const priceInfo = await ShiftRequest._getPrice(serviceType, serviceProviderId, sourceCountryId, destinationCountryId, payingCurrencyId, payoutCurrencyId, payingAmount, 0, platform, payoutBranchCode = requiredBranch.toUpperCase() !== 'NO' ? payoutBranchCode : '')

            // const priceInfo = await postData('http://localhost:3000/getPrice', {
            //     serviceType,
            //     serviceProviderId,
            //     sourceCountryId,
            //     destinationCountryId,
            //     payingCurrencyId,
            //     payoutCurrencyId,
            //     payingAmount,
            //     payoutAmount: 0,
            //     platform,
            //     payoutBranchCode: requiredBranch.toUpperCase() !== 'NO' ? payoutBranchCode : ''
            // })


            if (priceInfo['ns3:remittancePrice']) {
                let rate;
                setTimeout(() => {
                    const firstInput = document.querySelector('#paying-amount');
                    const secondInput = document.querySelector('#payout-amount');

                    const options2 = document.querySelectorAll('#payout-currency option');
                    const select2 = document.querySelector('#payout-currency');
                    let s, s1;
                    options2.forEach(val => {
                        if (val.value === select2.value) {
                            s = val.textContent;
                        }
                    });

                    const options1 = document.querySelectorAll('#paying-currency option');
                    const select1 = document.querySelector('#paying-currency');

                    options1.forEach(val => {
                        if (val.value === select1.value) {
                            s1 = val.textContent;
                        }
                    });

                    // console.log(firstInput.value, secondInput.value)

                    rate = secondInput.value / firstInput.value;
                    let firstRate = firstInput.value / firstInput.value;

                    const html = `
                    <p>
                    <strong>Current rate</strong>: ${firstRate} ${s1} = ${rate.toFixed(4)} ${s}
                    </p>
                    `
                    document.querySelector('#result').insertAdjacentHTML('afterbegin', html);

                    // $('#result').append($('<p>', {
                    //     // html: `<strong> Current Rate </strong>: ${priceInfo['ns3:remittancePrice']['ns3:exchangeRate']._}`
                    //     html: `<strong> Current Rate </strong>: ${rate}`
                    // }));
                }, 800);

                const options1 = document.querySelectorAll('#paying-currency option');
                const select1 = document.querySelector('#paying-currency');
                let s1;
                options1.forEach(val => {
                    if (val.value === select1.value) {
                        s1 = val.textContent;
                    }
                });

                $('#payout-amount').val(priceInfo['ns3:remittancePrice']['ns3:payoutAmount']._);

                if (!priceInfo['ns3:paymentMethods']) $('#result').append($('<p>', {
                    html: `<strong>Charges</strong>: ${priceInfo['ns3:remittancePrice']['ns3:totalCharges']._} ${s1}`
                }));


                else {
                    setTimeout(() => {
                        if (priceInfo['ns3:paymentMethods'].length) {
                            priceInfo['ns3:paymentMethods'].forEach((method, i) => {
                                let length;
                                let charge;

                                if (method['ns3:charges']._ % 1 === 0) {
                                    length = method['ns3:charges']._ + '';
                                    charge = `${method['ns3:charges']._}.`.padEnd(length.length + 3, '0');
                                } else {
                                    length = method['ns3:charges']._ + '';
                                    charge = `${method['ns3:charges']._}`.padEnd(length.length + 1, '0');
                                }

                                const asd = i === 0 ? charge : method['ns3:charges']._;

                                if (i === 0) {
                                    const span = document.createElement('p');
                                    span.classList.add('main-payment-methods');
                                    span.textContent = 'Payment Methods';

                                    document.querySelector('#result').insertAdjacentElement('afterbegin', span);
                                }

                                $('#result').append($('<p>', {
                                    html: `<strong>${method['ns3:name']._}</strong>: ${asd} ${s1}`
                                }));
                            });
                        } else {
                            let length;
                            let charge;

                            if (priceInfo['ns3:paymentMethods']['ns3:charges']._ % 1 === 0) {
                                length = priceInfo['ns3:paymentMethods']['ns3:charges']._ + '';
                                charge = `${priceInfo['ns3:paymentMethods']['ns3:charges']._}.`.padEnd(length.length + 3, '0');
                            } else {
                                length = priceInfo['ns3:paymentMethods']['ns3:charges']._ + '';
                                charge = `${priceInfo['ns3:paymentMethods']['ns3:charges']._}`.padEnd(length.length + 1, '0');
                            }

                            const asd = priceInfo['ns3:paymentMethods']['ns3:charges']._;

                            const span = document.createElement('p');
                            span.classList.add('main-payment-methods');
                            span.textContent = 'Payment Methods';

                            document.querySelector('#result').insertAdjacentElement('afterbegin', span);


                            $('#result').append($('<p>', {
                                html: `<strong>${priceInfo['ns3:paymentMethods']['ns3:name']._}</strong>: ${asd} ${s1}`
                            }));
                        }

                    }, 800);
                }


                $('#redirect').text('Continue Transaction')
                $('#redirect').addClass('redirect-active');

                btnB.style.display = 'block';
                const ress = document.querySelector('#amount-input #result');
                ress.insertAdjacentElement('beforeend', btnB);
            }

            if (supportSourceLoyality.toUpperCase() === 'YES') $('#redirect').text('Continue Transaction')
            else {
                $('#redirect').text('Continue Transaction')
                $('#redirect').addClass('redirect-active');
            }
        }

        if (state === 'payout-amount-changed') {
            $('#paying-amount').val(0)
            updatePriceInputs(11)
            let {
                serviceType,
                serviceProviderId,
                sourceCountryId,
                destinationCountryId,
                payingCurrencyId,
                payoutCurrencyId,
                payoutAmount,
                platform,
                payoutBranchCode,
                requiredBranch,
                supportSourceLoyality
            } = getPriceData

            if (!payingCurrencyId || !payoutCurrencyId) return

            const priceInfo = await ShiftRequest._getPrice(serviceType, serviceProviderId, sourceCountryId, destinationCountryId, payingCurrencyId, payoutCurrencyId, 0, payoutAmount, platform, payoutBranchCode = requiredBranch.toUpperCase() !== 'NO' ? payoutBranchCode : '')

            // const priceInfo = await postData('http://localhost:3000/getPrice', {
            //     serviceType,
            //     serviceProviderId,
            //     sourceCountryId,
            //     destinationCountryId,
            //     payingCurrencyId,
            //     payoutCurrencyId,
            //     payingAmount: 0,
            //     payoutAmount,
            //     platform,
            //     payoutBranchCode: requiredBranch.toUpperCase() !== 'NO' ? payoutBranchCode : ''
            // })
            if (priceInfo['ns3:remittancePrice']) {

                let rate;
                setTimeout(() => {
                    $('#paying-amount').val(priceInfo['ns3:remittancePrice']['ns3:payingAmount']._)
                    const firstInput = document.querySelector('#paying-amount');
                    const secondInput = document.querySelector('#payout-amount');

                    const options2 = document.querySelectorAll('#payout-currency option');
                    const select2 = document.querySelector('#payout-currency');

                    let s, s1;

                    options2.forEach(val => {
                        if (val.value === select2.value) {
                            s = val.textContent;
                        }
                    });

                    const options1 = document.querySelectorAll('#paying-currency option');
                    const select1 = document.querySelector('#paying-currency');

                    options1.forEach(val => {
                        if (val.value === select1.value) {
                            s1 = val.textContent;
                        }
                    });

                    rate = secondInput.value / firstInput.value;
                    let firstRate = firstInput.value / firstInput.value;

                    const html = `
                    <p>
                      <strong>Current rate</strong>: ${firstRate} ${s1} = ${rate.toFixed(4)} ${s}
                    </p>
                    `
                    document.querySelector('#result').insertAdjacentHTML('afterbegin', html);

                    // $('#result').append($('<p>', {
                    //     // html: `<strong> Current Rate </strong>: ${priceInfo['ns3:remittancePrice']['ns3:exchangeRate']._}`
                    //     html: `<strong> Current Rate </strong>: ${rate}`
                    // }));

                    if (!priceInfo['ns3:paymentMethods']) {
                        $('#result').append($('<p>', {
                            text: `${priceInfo['ns3:remittancePrice']['ns3:totalCharges']._} ${s1}`
                        }))
                    } else {
                        priceInfo['ns3:paymentMethods'].forEach((method, i) => {
                            const asd = i === 0 ? '.00' : '';

                            if (i === 0) {
                                const span = document.createElement('p');
                                span.classList.add('main-payment-methods');
                                span.textContent = 'Payment Methods';

                                document.querySelector('#result').insertAdjacentElement('afterbegin', span);
                            }

                            $('#result').append($('<p>', {
                                text: `${method['ns3:name']._} ${method['ns3:charges']._}${asd} ${s1}`
                            }))
                        })
                    }
                }, 800);


                btnB.style.display = 'block';
                const ress = document.querySelector('#amount-input #result');
                ress.insertAdjacentElement('beforeend', btnB);
            }

            if (supportSourceLoyality.toUpperCase() === 'YES') $('#redirect').text('Continue Transaction')
            else $('#redirect').text('FIND LOCATION')
        }
    }

    const searchField = (targetInput, arrayList) => {
        if (document.querySelector(`${targetInput}`)) {
            const inputBox = document.querySelector(`${targetInput}`);
            const spans = document.querySelectorAll(`${arrayList}`);

            inputBox.addEventListener('keyup', function (e) {
                let userData = e.target.value;
                let arr = [];

                spans.forEach(val => {
                    // const span = val.querySelectorAll('span')[1];
                    // span.classList.add('hidden-item');
                    //
                    // console.log(span);

                    val.classList.add('hidden-item');
                });

                if (userData) {
                    arr = [...spans].filter(data => {
                        const span = data.querySelectorAll('span')[1];
                        return span.textContent.toLowerCase().startsWith(userData.toLowerCase());
                    });

                    arr = arr.map(data => {
                        let createLi = document.createElement('li');
                        createLi.textContent = data.textContent;
                        return data = createLi;
                    });

                    arr.forEach((searched, i) => {
                        [...spans].forEach(val => {
                            if (val.textContent == searched.textContent) {
                                val.classList.remove('hidden-item');
                            }
                        });
                    });
                } else spans.forEach(val => {
                    val.classList.remove('hidden-item');
                });

            });
        }
    }

    let res = '';

    async function runLocationState(state = 'init', props = {}) {
        locationData = {...locationData, ...props}

        if (state === 'init') {
            $('#location-country').empty()

            const destCountry = document.querySelector('#location-city + .select2');
            destCountry.classList.add('selector-disabled');
            destCountry.style.pointerEvents = 'none';

            const showLoc = document.querySelector('#show-locations');
            showLoc.style.pointerEvents = 'none';

            const network_countries = await ShiftRequest._getNetworkCountries();

            // const network_countries = await postData('http://localhost:3000/getNetworkCountries', {})

            network_countries.forEach((sc) => {
                $('#location-country').append($('<option>', {
                    value: `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}`,
                    text: sc['ns3:countryNameEn']._,
                    selected: sc['ns3:countryId']._ === 232
                }));
            })

            if (document.querySelector('.location-list')) {


                const locationList = document.querySelector('.location-list');
                const countrySelect = document.querySelector('#location-country');

                locationList.innerHTML = '';

                network_countries.forEach(sc => {
                    let div = document.createElement('div');
                    div.classList.add('network-countries');
                    div.classList.add('country-block');

                    let flagSpan = document.createElement('span');
                    flagSpan.classList.add('country-flag');

                    let flagSpanImg = document.createElement('img');

                    let getId = `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}`;
                    let str = getId.substr(0, getId.indexOf('_'));
                    // flagSpanImg.setAttribute(`src`, `/assets/images/flags/${str}.png`);

                    div.setAttribute('data-country-id', `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}`);
                    div.setAttribute('data-country', sc['ns3:countryNameEn']._);
                    div.setAttribute('data-id', str);

                    flagSpan.setAttribute('data-country-id', `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}`);
                    flagSpan.setAttribute('data-country', sc['ns3:countryNameEn']._);
                    flagSpan.setAttribute('data-id', str);

                    let span = document.createElement('span');
                    span.setAttribute('data-country-id', `${sc['ns3:countryId']._}_${sc['ns3:countryId']._ === 232 ? 'UK' : sc['ns3:platform']._}`);
                    // span.setAttribute('data-selected-country-id', sc['ns3:countryId']._ === 127);
                    span.setAttribute('data-country', sc['ns3:countryNameEn']._);
                    span.classList.add('selected-country');
                    span.setAttribute('data-id', str);

                    span.textContent = sc['ns3:countryNameEn']._;

                    flagSpan.append(flagSpanImg);
                    div.append(flagSpan);
                    div.append(span);
                    locationList.append(div);

                    if (div.getAttribute('data-country-id').includes('127')) {
                        div.classList.add('active');

                        const cloneNode = div.cloneNode(true);
                        const active = document.querySelector('.active-location-list');
                        active.innerHTML = '';
                        active.append(cloneNode);
                    }

                    div.addEventListener('click', function () {
                        countrySelect.value = this.getAttribute('data-country-id');
                        countrySelect.dispatchEvent(new Event("change"));

                        this.classList.add('active-block');

                        const cloneNode = this.cloneNode(true);

                        const activeLocatiionList = document.querySelector('.active-location-list');
                        activeLocatiionList.innerHTML = '';

                        activeLocatiionList.append(cloneNode);
                    });
                });
            }

            runLocationState('country-selected');
            searchField('.input-box', '.location-list .country-block');
        }

        if (state === 'country-selected') {
            $('#location-city').empty()
            $('#location-result').empty()
            $('#location-city').append($('<option>', {value: 0, text: 'City'}));
            const {countryId, platform} = locationData
            const countryCities = await ShiftRequest._getCountryCities(countryId, platform)

            countryCities.forEach((sc) => {
                const destCountry = document.querySelector('#location-city + .select2');
                destCountry.classList.remove('selector-disabled');
                destCountry.style.pointerEvents = 'all';

                const showLoc = document.querySelector('#show-locations');
                showLoc.style.pointerEvents = 'all';
                $('#location-city').append($('<option>', {
                    value: sc['ns3:cityId']._,
                    text: sc['ns3:cityEnglishName']._
                }));
            })

            if (document.querySelector('#location-city')) {
                const locationCity = document.querySelector('#location-city');

                if (locationCity.value == 0) {
                    const blockRes = document.querySelector('#location-result');
                    const resSpan = document.createElement('span');
                    resSpan.classList.add('location-result-empty');
                    resSpan.textContent = 'No results found.';
                    blockRes.insertAdjacentElement('beforeend', resSpan);
                }
            }

            if (document.querySelector('#location-city') && document.querySelector('.secondary-location-list')) {
                const locationCitySelect = document.querySelector('#location-city');
                const secondarylocationList = document.querySelector('.secondary-location-list');

                secondarylocationList.innerHTML = '';

                countryCities.forEach(sc => {
                    let div = document.createElement('div');
                    div.classList.add('country-cities');
                    div.classList.add('country-block');

                    let flagSpan = document.createElement('span');
                    flagSpan.classList.add('country-flag');

                    flagSpan.setAttribute('data-city-id', sc['ns3:cityId']._);
                    flagSpan.setAttribute('data-city-name', sc['ns3:cityEnglishName']._);

                    div.setAttribute('data-city-id', sc['ns3:cityId']._);
                    div.setAttribute('data-city-name', sc['ns3:cityEnglishName']._);

                    let span = document.createElement('span');
                    span.classList.add('country-selected-span');
                    span.setAttribute('data-city-id', sc['ns3:cityId']._);
                    span.setAttribute('data-city-name', sc['ns3:cityEnglishName']._);
                    span.textContent = sc['ns3:cityEnglishName']._;

                    div.append(flagSpan);
                    div.append(span);
                    secondarylocationList.append(div);

                    div.addEventListener('click', function () {
                        locationCitySelect.value = this.getAttribute('data-city-id');
                        locationCitySelect.dispatchEvent(new Event("change"));

                        this.classList.add('active-block');

                        const cloneNode = this.cloneNode(true);

                        const activeLocatiionList = document.querySelector('.active-secondary-location-list');
                        activeLocatiionList.innerHTML = '';

                        activeLocatiionList.append(cloneNode);
                    });
                });
            }

            searchField('.input-box-cities', '.secondary-location-list .country-block');
        }

        if (state === 'display-locations') {
            const {countryId, cityCode, platform} = locationData
            if (!countryId || !cityCode) return

            if (document.querySelector('.result-country-location')) {
                const removePrev = document.querySelector('.result-country-location');
                removePrev.remove();
            }

            const resultDiv = document.createElement('div');
            const locations = await ShiftRequest._getLocations(countryId, cityCode, platform);

            // const filteredLocations = locations.filter(val => val['ns3:Address'].includes('Vilnius'));

            console.log(locations);
            let lat, lng;
            const filterLocations = locations?.filter(val => {
                let str = `${val['ns3:City']._}`.toLowerCase().trim();
                if (str.includes(res.toLowerCase().trim())) return str;
            });

            const modal = document.querySelector('#test-modal');
            const mapBlock = document.querySelector('.map-block');

            filterLocations?.forEach(val => {
                lat = val['ns3:latitude'];
                lng = val['ns3:longitude'];
            });

            console.log('changed to UK');
            const mapFl = filterLocations?.filter(val => {
                if (val['ns3:latitude']?._ !== 0 && val['ns3:longitude']?._ !== 0) {
                    if (val['ns3:latitude'] && val['ns3:longitude']) {
                        modal.classList.add('full-size-modal');
                        return val;
                    }
                }
            });

            if (mapFl.length === 0) {
                modal.classList.remove('full-size-modal');
            }

            for (let i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }

            let pos, latCenter = 0, lonCetner = 0;

            mapFl.forEach((val, i) => {
                pos = {lat: val['ns3:latitude']._, lng: val['ns3:longitude']._};

                const image =
                    "/wp-content/themes/wam/assets/images/pin.svg";
                const marker = new google.maps.Marker({
                    position: pos,
                    map,
                    icon: image,
                });

                markers.push(marker);

                latCenter += val['ns3:latitude']._;
                lonCetner += val['ns3:longitude']._;

                const url = `https://www.google.com/maps/place/${pos.lat}+${pos.lng}`;
                const address = val['ns3:Address']._;

                const message =
                    `<div>
                    <a class="location-adderess" href="${url}" target="_blank">
                        <div>${address}</div>
                    </a>
                </div>`;

                attachSecretMessage(marker, message, i, pos);
            });

            let infowindow = new google.maps.InfoWindow({
                pixelOffset: new google.maps.Size(0, -3),
            });

            function attachSecretMessage(marker, secretMessage, index, pos) {
                if (screen.width > 768) {
                    marker.addListener("click", () => {
                        infowindow.setContent(secretMessage);
                        infowindow.open(map, marker);
                        map.panTo(pos);
                    });
                }
            }

            const ress = {
                lat: latCenter / mapFl.length,
                lng: lonCetner / mapFl.length,
            }

            if (ress.lat && ress.lng) {
                map.setCenter(ress);
            }

            const locationCity = document.querySelector('#location-city');

            if (locationCity.value == 0) {
                const blockRes = document.querySelector('#location-result');
                const resSpan = document.createElement('span');
                resSpan.classList.add('location-result-empty');
                resSpan.textContent = 'No results found.';
                blockRes.insertAdjacentElement('beforeend', resSpan);
            }

            if (filterLocations.length) {
                $('#location-result').html(`
              ${filterLocations.map((l) => `
                <div>
                            <p class="branch-name">${l['ns3:BranchName']._}</p>
                            ${l['ns3:Address']?._ ? `<p class="adress"><span>Address: </span>${l['ns3:Address']._}</p>` : ''}
                            ${l['ns3:Telephone']?._ ? `<p class="phone"><span>Telephone: </span>${l['ns3:Telephone']._}</p>` : ''}
                            <a target="_blank" href="https://www.google.com/maps/place/${l['ns3:latitude'] ? l['ns3:latitude']._ + '+' + l['ns3:longitude']._ : l['ns3:Address']._}" class="directions">
                                <img src="/wp-content/themes/wam/assets/images/icon-arrow-purple.svg">
                                Get directions
                            </a>
                          </div>
              `).join(' ')}
            `)

                const countryheading = document.createElement('h2');
                const countryheading2 = document.createElement('h2');
                const selectLocationCity = document.querySelector('#location-city');
                const selectCountry = document.querySelector('#location-country');

                const options = selectCountry.querySelectorAll('option');
                const options2 = selectLocationCity.querySelectorAll('option');

                countryheading2.innerHTML = '';
                countryheading.innerHTML = '';

                let getTextCountry = '', getTextCity = '';

                options.forEach(val => {
                    if (val.value === selectCountry.value) {
                        getTextCountry = val.textContent;
                    }
                });

                options2.forEach(val => {
                    if (val.value === selectLocationCity.value) {
                        getTextCity = val.textContent;
                    }
                });

                countryheading.textContent = getTextCountry;
                countryheading2.textContent = getTextCity;

                countryheading.classList.add('country-heading');
                countryheading2.classList.add('country-heading-city');

                const result = document.querySelector('#location-result');

                resultDiv.classList.add('result-country-location');

                resultDiv.insertAdjacentElement('beforeend', countryheading);
                resultDiv.insertAdjacentElement('beforeend', countryheading2);
                result.insertAdjacentElement('beforebegin', resultDiv);
            } else {
                document.querySelector('#location-result').innerHTML = '';
                const blockRes = document.querySelector('#location-result');
                const resSpan = document.createElement('span');
                resSpan.classList.add('location-result-empty');
                resSpan.textContent = 'No results found.';
                blockRes.insertAdjacentElement('beforeend', resSpan);
            }
        }
    }


// const btn = document.querySelector('#show-locations');
//
// btn.addEventListener('click', () => {
//     runLocationState('display-locations')
//     console.log('clicked');
// })

    async function getTransferStatus(inputId) {
        //omnly uk wihout platform
        const {remittancTrackingCode, platform} = transferData
        const code = document.querySelectorAll('#refference-number');

        const transfer_status = await ShiftRequest._getRemittanceStatus(code[inputId].value, 'UK');

        const status = transfer_status[0]._ ? transfer_status[0]._ : `Transfer number can't be found`;

        const statuses = document.querySelectorAll('#transfer-status');
        console.log(statuses);

        statuses.forEach(val => {
            val.innerHTML = `
            <div class='respsonse'><span>Status: </span>${status}</div>
            `;
        });

        // $('#transfer-status').html("<div class='respsonse'><span>Status: </span> " + status + "</div>");
    }

    $(document).ready(function () {
// GET PRICE
        $("#get-price").ready(async function () {
            runPriceState()
        });

        $('#source-countries').on('change', async function () {
            const sourceCountryId = Number(this.value.split('_')[0])
            const platform = this.value.split('_')[1]
            const supportSourceLoyality = this.value.split('_')[2]
            runPriceState('source-country-selected', {sourceCountryId, platform, supportSourceLoyality})


            const servProv = document.querySelector('[data-select2-id^="select2-data-6-"]');
            servProv.style.display = 'none';

            const destCountry = document.querySelector('#destination-countries + .select2');
            destCountry.classList.add('selector-disabled');
            destCountry.style.pointerEvents = 'none';

            //serv types disable
            const destCountryy = document.querySelector('#service-type + .select2');
            destCountryy.classList.add('selector-disabled');
            destCountryy.style.pointerEvents = 'none';

            const destCountryyy = document.querySelector('#service-provider + .select2');
            destCountryyy.classList.add('selector-disabled');
            destCountryyy.style.pointerEvents = 'none';
        });

        $('#destination-countries').on('change', async function () {
            const destinationCountryId = Number(this.value.split('_ST:')[0])
            let serviceTypes = JSON.parse(this.value.split('_ST:')[1])
            if (!Array.isArray(serviceTypes)) serviceTypes = [serviceTypes]

            runPriceState('destination-country-selected', {destinationCountryId, serviceTypes})

            const servProv = document.querySelector('[data-select2-id^="select2-data-6-"]');
            servProv.style.display = 'none';
        })

        $('#service-type').on('change', async function () {
            const serviceType = this.value
            runPriceState('service-type-selected', {serviceType})

            const destCountry = document.querySelector('#service-provider + .select2');
            destCountry.classList.add('selector-disabled');
            destCountry.style.pointerEvents = 'none';
        })

        $('#service-provider').on('change', async function () {
            const serviceProviderId = Number(this.value.split('_')[0])
            const requiredBranch = this.value.split('_')[1]
            runPriceState('service-provider-selected', {requiredBranch, serviceProviderId})
        })

        $('#paying-currency').on('change', async function () {
            const payingCurrencyId = this.value
            runPriceState('currency-changed', {payingCurrencyId})
        })

        $('#payout-currency').on('change', async function () {
            const payoutCurrencyId = this.value
            runPriceState('currency-changed', {payoutCurrencyId})
            //
            // //xxx
            // const payingAmount = document.querySelector('#paying-amount').value;
            // runPriceState('paying-amount-changed', {payingAmount})
        })

        $('#paying-amount').keypress(debounce(async function () {
            const payingAmount = this.value
            runPriceState('paying-amount-changed', {payingAmount})
            $('#redirect').removeClass('redirect-active');
        }, 500))

        $('#payout-amount').keypress(debounce(async function () {
            const payoutAmount = this.value
            runPriceState('payout-amount-changed', {payoutAmount})
            $('#redirect').removeClass('redirect-active');
        }, 500))

// FIND LOCATION
        $("#get-location").ready(async function () {
            runLocationState()
        })
        $('#location-country').on('change', async function () {
            const countryId = Number(this.value.split('_')[0])
            const platform = this.value.split('_')[1]
            runLocationState('country-selected', {countryId, platform})

            const destCountry = document.querySelector('#location-city + .select2');
            destCountry.classList.add('selector-disabled');
            destCountry.style.pointerEvents = 'none';

            const showLoc = document.querySelector('#show-locations');
            showLoc.style.pointerEvents = 'none';
        })
        $('#location-city').on('change', async function () {
            locationData.cityCode = Number(this.value)
            $('#location-result').empty()

            const options = document.querySelectorAll('#location-city option');

            options.forEach(val => {
                if (val.value.toLowerCase() === this.value.toLowerCase()) {
                    res = val.textContent;
                }
            })
        });

// TRANSFER STATUS
        $("#refference-number").keypress(debounce(async function () {
            transferData.remittancTrackingCode = this.value
        }, 50))

    });

    if (document.querySelector('#show-locations')) {
        const showLocation = document.querySelector('#show-locations');

        showLocation.addEventListener('click', async () => {
            await runLocationState("display-locations");
        });
    }

    if (document.querySelector('#country-select-end')) {
        //buttons replace
        const btnPriceCalc = document.querySelector('#country-select-end');

        btnPriceCalc.addEventListener('click', async () => {
            await runPriceState("country-select-end");
            const first = document.querySelector('#paying-amount');
            const secodn = document.querySelector('#payout-amount');

            first.value = 100;
            secodn.value = '';
            first.placeholder = '100';

            setTimeout(() => {
                document.querySelector('#paying-amount').dispatchEvent(new Event("keypress"));
            }, 2000);
        });
    }

    if (document.querySelector('#statusBtn')) {
        const statusBtn = document.querySelectorAll('#statusBtn');
        console.log(statusBtn);

        statusBtn.forEach((val, i) => val.addEventListener('click', async () => {
            await getTransferStatus(i);
        }));

        // statusBtn.addEventListener('click', async () => {
        //
        // });
    }

    if (document.querySelector('#priceCalc')) {
        const btnBack = document.querySelector('#priceCalc');
        btnBack.style.display = 'none';

        btnBack.addEventListener('click', async () => {
            await runPriceState('service-type-selected');
        });
    }

    //popular countries

    if (document.querySelector('.page-template-page-countries-currencies')) {
        const shiftCountries = document.querySelector('.countries-block .countries-wrap');
        (async () => {
            const result = await ShiftRequest._getDestinationCountries(127, 'LT');
            const content = [];
            let res = {};

            const serviceTypes = [], countries = [], currencies = [], fullCurrencies = [], ids = [];

            Promise.all(result).then(values => {
                const reqArr = values.map(country => ShiftRequest._getPayingCurrencies(country['ns3:countryId']._));
                values.forEach((val, i) => {
                    const serv = val['ns3:serviceTypes'];
                    const countryName = val['ns3:countryNameEn']._;
                    const id = val['ns3:countryId']._;

                    ids.push(id);
                    serviceTypes.push(serv);
                    countries.push(countryName);
                });

                serviceTypes.forEach((val, i) => {
                    const countryInfo = {
                        country: countries[i],
                        serviceTypes: val,
                        id: ids[i],
                    }

                    content.push(countryInfo);
                });

                shiftCountries.innerHTML = '';

                content.forEach(({country, serviceTypes, id}) => {
                    let countryDiv = document.createElement('div');
                    countryDiv.classList.add('single');
                    countryDiv.setAttribute('data-country-id', id);

                    let img = document.createElement('img');
                    img.src = `/wp-content/themes/wam/assets/images/flags/${id}.png`;

                    countryDiv.insertAdjacentElement('afterbegin', img);

                    let countrySpan = document.createElement('span');
                    countrySpan.classList.add('shift-single-country');
                    countrySpan.textContent = country;

                    let innerInfo = document.createElement('div');
                    innerInfo.classList.add('single-inner-info');

                    let serviceInfo = document.createElement('div');
                    serviceInfo.classList.add('single-service-info');

                    [serviceTypes].forEach(val => {
                        if (val instanceof Array) {
                            val.forEach(val => {
                                let serviceSpan = document.createElement('span');
                                serviceSpan.classList.add('serviceSpan');
                                serviceSpan.textContent = val._;

                                serviceInfo.insertAdjacentElement('beforeend', serviceSpan);
                            });
                        } else {
                            let serviceSpan = document.createElement('span');
                            serviceSpan.classList.add('serviceSpan');
                            serviceSpan.textContent = val._;

                            serviceInfo.insertAdjacentElement('beforeend', serviceSpan);
                        }
                    });

                    countryDiv.insertAdjacentElement('beforeend', countrySpan);
                    countryDiv.insertAdjacentElement('beforeend', innerInfo);
                    innerInfo.insertAdjacentElement('beforeend', serviceInfo);
                    shiftCountries.insertAdjacentElement('beforeend', countryDiv);
                });
                //
                //
                // async function hoverRequest(countryId){
                //     return await ShiftRequest._getPayingCurrencies(countryId, 'UK');
                // }
                //
                // const singleItems = shiftCountries.querySelectorAll('.single');
                //
                // singleItems.forEach(val => {
                //     val.addEventListener('mouseover', () => {
                //         // console.log(val.getAttribute('data-country-id'));
                //
                //         Promise.all(ShiftRequest._getPayingCurrencies(val.getAttribute('data-country-id'), 'UK')).then(data => {
                //             console.log(data);
                //         });
                //     });
                // });

                $(".countries-wrap .shift-single-country").on("mouseover", function () {
                    this.parentElement.classList.add('hover');
                });

                $(".countries-wrap .shift-single-country").on("mouseout", function () {
                    this.parentElement.classList.remove('hover');
                });
            });
        })();
    }

    const trn = document.querySelector('.menu-item-74 > a');
    trn.addEventListener('click', () => {
        document.querySelector('#transfer-status').innerHTML = '';
        document.querySelector('#refference-number').value = '';
    });

    const selects = document.querySelectorAll('.select2-selection__rendered');

    selects.forEach(val => val.addEventListener('click', () => {
        const allLi = document.querySelectorAll('.select2-results__option');

        allLi.forEach(val => {
            if (val.firstElementChild?.firstElementChild?.getAttribute('src').includes('0.png')) {
                val.style.display = 'none';
            }
        })
    }))

    const servProv = document.querySelector('[data-select2-id^="select2-data-6-"]');
    servProv.style.display = 'none';

    const showLoc = document.querySelector('#show-locations');
    showLoc.style.pointerEvents = 'none';


    // const btn = document.querySelector('.test-modal .mfp-close');
    // const bg = document.querySelector('.mfp-bg');
    //
    // const rmv = [btn, bg];
    //
    // rmv?.forEach(val => {
    //     val.addEventListener('click', () => {
    //         console.log('clicked');
    //
    //     });
    // });

    // $.magnificPopup.instance.st.callbacks = {
    //     close: function() {
    //         alert('test3')
    //         const modal = document.querySelector('.test-modal');
    //         modal.classList.remove('full-size-modal');
    //     }
    // }

    // const btns = document.querySelectorAll('.navigation .line');
    // const statuses = document.querySelectorAll('#transfer-status');
    //
    // console.log(...btns, '12');
    //
    // btns.forEach((val, i) => val.addEventListener('click', () => {
    //     statuses[i].innerHTML = '';
    // }));
});
